import React from 'react';

import { setLocale as setYupLocale } from 'yup';
import Polyglot from 'node-polyglot';
import { languages } from './constants';
import dayjs from 'dayjs';
import version from 'src/config/version.json';

let currentLanguageCode = '';

const polyglot = new Polyglot();
export const DEFAULT_LANGUAGE = 'en';

export async function init(lang?: string) {
  const browserLang = window.navigator.language.split('-')[0];

  const savedLanguage = lang || localStorage.getItem('language') || browserLang;
  currentLanguageCode =
    savedLanguage && languages[savedLanguage]
      ? savedLanguage
      : DEFAULT_LANGUAGE;
  setLanguageCode(currentLanguageCode);

  const language = getLanguage();

  try {
    const response = await fetch(
      `/translations/${currentLanguageCode}.json?vs=${version.version}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      },
    );
    const data = await response.json();

    polyglot.locale(currentLanguageCode);

    polyglot.extend(data);

    dayjs.locale(language.date);

    if (data.validation) {
      setYupLocale(data.validation);
    }
  } catch (err) {
    console.error(err);
  }
}

function getLanguage() {
  return languages[getLanguageCode()];
}

export function getLanguages() {
  return Object.values(languages);
}

export function getAntdLanguage() {
  return getLanguage().antd;
}

export function getDateLanguage() {
  return getLanguage().date;
}

export function getLanguageCode() {
  return currentLanguageCode;
}

export function setLanguageCode(arg) {
  const locale = languages[arg] ? arg : DEFAULT_LANGUAGE;

  localStorage.setItem('language', locale);
}

export function i18n(key, ...args) {
  return polyglot.t(key, ...args);
}

export function i18nHtml(key, ...args) {
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: i18n(key, ...args),
      }}
    />
  );
}
